<template>
  <div class="mx-2">
    <SectionTitle
      :is-big-icon="true"
      icon="fas fa-times-circle  fa-fw"
      content="Cancelación de Firmas"
      reverse
    />
    <div class="mt-3 mx-3">
      <validation-observer ref="formRef" tag="form" novalidate>
        <div class="mt-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <span class="data-title d-block mb-2">Razón de cancelación:</span>
            <custom-text-area
              id="txtCancellationReason"
              class="textarea__extended"
              v-model="model.reason"
              :maxlength="3000"
              show-char-count
              :count-classes="['d-block text-left']"
              :error="errors[0]"
              custom-error-msg="La razón de cancelación es requerida."
            />
          </validation-provider>
        </div>
        <div class="mt-2 d-flex flex-column flex-lg-row justify-content-lg-end">
          <action-button
            id="btnCancel"
            text="Cancelar"
            variant="outline-danger"
            i="fas fa-times-circle"
            class="w-auto w-lg-0"
            @click="onCancelHandler"
          />
          <div class="my-1 mx-1 my-lg-0 mx-lg-2" />
          <action-button
            id="btnSave"
            text="Guardar"
            variant="success"
            i="fas fa-save"
            class="w-auto w-lg-0"
            @click="onSaveHandler"
          />
        </div>
      </validation-observer>
    </div>
  </div>
</template>
<script>
//libs
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";
import SectionTitle from "SectionTitle";

//mixins
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";

//store
import store from "@/store";

//services
import generalService from "@/services/pei/general";

export default {
  name: "SignatureCancellation",
  mixins: [alertMixin],
  components: {
    IconView,
    SectionTitle,
    CustomTextArea,
    ActionButton
  },
  data: () => ({
    model: {
      reason: null
    }
  }),
  computed: {
    selectedPeiId() {
      return store.getters.SelectedPei;
    }
  },
  methods: {
    onCancelHandler() {
      store.commit("setShowSignatureCancellationDocument", false);
    },
    async onSaveHandler() {
      const isValid = await this.$refs.formRef.validate();
      if (!isValid) {
        this.ShowToast("Error", "Informacion incompleta.", "error");
        return;
      }

      const answer = await this.ShowCancelModal(
        "Atención",
        "¿Está seguro(a) que desea cancelar el proceso de firma digital?",
        "Sí",
        "No"
      );
      if (answer) {
        try {
          const { data } = await generalService.cancelDigitalSignature(
            this.selectedPeiId,
            this.model.reason
          );
          if (data) {
            this.ShowToast(
              "",
              "El proceso de firma electrónica ha sido cancelado exitosamente.",
              "success"
            );
            this.onCancelHandler();
            this.$emit("refresh-digital-signature");
          } else {
            this.ShowToast(
              "",
              "No hay documentos relacionados al PEI.",
              "error"
            );
          }
        } catch {
          this.ShowToast(
            "",
            "Error en el proceso de cancelación de firma digital",
            "error"
          );
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.textarea__extended ::v-deep {
  .position-relative {
    i {
      display: none;
    }
  }
}
</style>
